module.exports = __webpack_public_path__ + "static/media/twitter-footer.55d82ace.svg";